import { render } from "./RoundCounter.vue?vue&type=template&id=79199948&scoped=true"
const script = {}

import "./RoundCounter.vue?vue&type=style&index=0&id=79199948&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-79199948"]])

export default __exports__